import React from 'react';
import PublicLayout from '../components/PublicLayout';
import ContactUsGrid from '../components/ContactUsGrid';
const h=React.createElement;
export default function Contact(props) {
  return h(PublicLayout,{page:'contact',isLoggedIn:props.isLoggedIn},
    h(ContactUsGrid,{isLoggedIn:props.isLoggedIn}));
}

